import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118a70a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "doc-sort__inner" }
const _hoisted_3 = { class: "doc-sort__list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "doc-sort__title" }
const _hoisted_6 = { class: "doc-sort__btn-box" }

import { onBeforeMount, ref } from 'vue'

import { DocsView } from '@/models/doc'
import { DocsSortMobileView as DocsSortView } from '@/models/docs.sort'
import { assertNotNull } from '@/helpers/typing'
import { emitter } from '@/services/mitt'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocsSort.mobile',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: DocsView
};



const sortView = ref<DocsSortView | null>(null)

onBeforeMount(async () => {
  sortView.value = new DocsSortView(props.view)
  emitter.on('openSortPopup', () => {
    show()
  })
})

function hide(): void {
  assertNotNull(sortView.value).hide()
}

function show(): void {
  assertNotNull(sortView.value).show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "doc-sort",
        onClick: _withModifiers(hide, ["self"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortView.value.options, (opt) => {
              return (_openBlock(), _createElementBlock("li", {
                key: opt.name,
                class: _normalizeClass(["doc-sort__item", sortView.value.activeOptionClass(opt)]),
                onClick: ($event: any) => (sortView.value.optionClick(opt))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["doc-sort__icon iconfont", opt.icon])
                  }, null, 2),
                  _createTextVNode(_toDisplayString(opt.name), 1)
                ])
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "doc-sort__btn btns",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sortView.value.applySort()))
            }, "Apply")
          ])
        ])
      ], 8, _hoisted_1), [
        [_vShow, sortView.value.visible]
      ])
    ]),
    _: 1
  }))
}
}

})